var _path, _g, _path2, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataTrackingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 221,
    viewBox: "0 0 112 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1676_28592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 96,
    height: 191
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 15C85.1718 15 60.881 25.0616 42.9713 42.9713C25.0616 60.881 15 85.1718 15 110.5C15 135.828 25.0616 160.119 42.9713 178.029C60.881 195.938 85.1718 206 110.5 206L110.5 110.5V15Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1676_28592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-tracking-main-circle",
    filter: "url(#filter0_f_1676_28592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 165,
    r: 75,
    fill: "#9A88DE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "data-tracking-main-segment",
    className: "data-tracking-main-segment"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1676_28592",
    className: "data-tracking-main-segment_mask",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 111,
    height: 270
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "data-tracking-main-segment-1",
    d: "M64.6789 9.94814C45.5699 18.6561 29.3378 32.6288 17.8839 50.2297C6.43004 67.8306 0.228682 88.3309 0.00620162 109.329L110.5 110.5L64.6789 9.94814Z",
    fill: "#212036"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1676_28592)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1676_28592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -8,
    cy: 65,
    r: 75,
    fill: "#9A88DE"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1676_28592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 29,
    width: 77,
    height: 177
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "data-tracking-chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.5625,
    y: 142,
    width: 20,
    height: 64,
    rx: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.5625,
    y: 29,
    width: 20,
    height: 177,
    rx: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.5625,
    y: 73,
    width: 20,
    height: 133,
    rx: 4,
    fill: "#D9D9D9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1676_28592)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1676_28592)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.689,
    cy: 112,
    rx: 126.923,
    ry: 75,
    fill: "#9A88DE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1676_28592",
    x: -149.2,
    y: -39.2,
    width: 408.4,
    height: 408.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.6,
    result: "effect1_foregroundBlur_1676_28592"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1676_28592",
    x: -212.2,
    y: -139.2,
    width: 408.4,
    height: 408.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.6,
    result: "effect1_foregroundBlur_1676_28592"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1676_28592",
    x: -43.4344,
    y: -92.2,
    width: 512.244,
    height: 408.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.6,
    result: "effect1_foregroundBlur_1676_28592"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTrackingImg);
export default __webpack_public_path__ + "static/media/DataTrackingImg.98faf6645d568716511084eb24a15307.svg";
export { ForwardRef as ReactComponent };